const colours = require("./colours-vars.json");

module.exports = {
  colours,
  customProperties: {
    "--colour-navy-50": colours.navy["50"],
    "--colour-navy-100": colours.navy["100"],
    "--colour-navy-200": colours.navy["200"],
    "--colour-navy-300": colours.navy["300"],
    "--colour-navy-400": colours.navy["400"],
    "--colour-navy-500": colours.navy["500"],
    "--colour-navy-600": colours.navy["600"],
    "--colour-navy-700": colours.navy["700"],
    "--colour-navy-800": colours.navy["800"],
    "--colour-navy-900": colours.navy["900"],
    "--colour-navy-950": colours.navy["950"],

    "--colour-primary-50": colours.navy["50"],
    "--colour-primary-100": colours.navy["100"],
    "--colour-primary-200": colours.navy["200"],
    "--colour-primary-300": colours.navy["300"],
    "--colour-primary-400": colours.navy["400"],
    "--colour-primary-500": colours.navy["500"],
    "--colour-primary-600": colours.navy["600"],
    "--colour-primary-700": colours.navy["700"],
    "--colour-primary-800": colours.navy["800"],
    "--colour-primary-900": colours.navy["900"],
    "--colour-primary-950": colours.navy["950"],

    "--colour-teal-50": colours.teal["50"],
    "--colour-teal-100": colours.teal["100"],
    "--colour-teal-200": colours.teal["200"],
    "--colour-teal-300": colours.teal["300"],
    "--colour-teal-400": colours.teal["400"],
    "--colour-teal-500": colours.teal["500"],
    "--colour-teal-600": colours.teal["600"],
    "--colour-teal-700": colours.teal["700"],
    "--colour-teal-800": colours.teal["800"],
    "--colour-teal-900": colours.teal["900"],
    "--colour-teal-950": colours.teal["950"],

    "--colour-accent-50": colours.teal["50"],
    "--colour-accent-100": colours.teal["100"],
    "--colour-accent-200": colours.teal["200"],
    "--colour-accent-300": colours.teal["300"],
    "--colour-accent-400": colours.teal["400"],
    "--colour-accent-500": colours.teal["500"],
    "--colour-accent-600": colours.teal["600"],
    "--colour-accent-700": colours.teal["700"],
    "--colour-accent-800": colours.teal["800"],
    "--colour-accent-900": colours.teal["900"],
    "--colour-accent-950": colours.teal["950"],

    "--colour-grey-50": colours.grey["50"],
    "--colour-grey-100": colours.grey["100"],
    "--colour-grey-200": colours.grey["200"],
    "--colour-grey-300": colours.grey["300"],
    "--colour-grey-400": colours.grey["400"],
    "--colour-grey-500": colours.grey["500"],
    "--colour-grey-600": colours.grey["600"],
    "--colour-grey-700": colours.grey["700"],
    "--colour-grey-800": colours.grey["800"],
    "--colour-grey-900": colours.grey["900"],
    "--colour-grey-950": colours.grey["950"],

    "--colour-neutral-50": colours.grey["50"],
    "--colour-neutral-100": colours.grey["100"],
    "--colour-neutral-200": colours.grey["200"],
    "--colour-neutral-300": colours.grey["300"],
    "--colour-neutral-400": colours.grey["400"],
    "--colour-neutral-500": colours.grey["500"],
    "--colour-neutral-600": colours.grey["600"],
    "--colour-neutral-700": colours.grey["700"],
    "--colour-neutral-800": colours.grey["800"],
    "--colour-neutral-900": colours.grey["900"],
    "--colour-neutral-950": colours.grey["950"],

    "--colour-slate-50": colours.slate["50"],
    "--colour-slate-100": colours.slate["100"],
    "--colour-slate-200": colours.slate["200"],
    "--colour-slate-300": colours.slate["300"],
    "--colour-slate-400": colours.slate["400"],
    "--colour-slate-500": colours.slate["500"],
    "--colour-slate-600": colours.slate["600"],
    "--colour-slate-700": colours.slate["700"],
    "--colour-slate-800": colours.slate["800"],
    "--colour-slate-900": colours.slate["900"],
    "--colour-slate-950": colours.slate["950"],

    "--colour-shade-50": colours.slate["50"],
    "--colour-shade-100": colours.slate["100"],
    "--colour-shade-200": colours.slate["200"],
    "--colour-shade-300": colours.slate["300"],
    "--colour-shade-400": colours.slate["400"],
    "--colour-shade-500": colours.slate["500"],
    "--colour-shade-600": colours.slate["600"],
    "--colour-shade-700": colours.slate["700"],
    "--colour-shade-800": colours.slate["800"],
    "--colour-shade-900": colours.slate["900"],
    "--colour-shade-950": colours.slate["950"],

    "--colour-white": colours.white,

    "--colour-poppy-50": colours.poppy["50"],
    "--colour-poppy-100": colours.poppy["100"],
    "--colour-poppy-200": colours.poppy["200"],
    "--colour-poppy-300": colours.poppy["300"],
    "--colour-poppy-400": colours.poppy["400"],
    "--colour-poppy-500": colours.poppy["500"],
    "--colour-poppy-600": colours.poppy["600"],
    "--colour-poppy-700": colours.poppy["700"],
    "--colour-poppy-800": colours.poppy["800"],
    "--colour-poppy-900": colours.poppy["900"],
    "--colour-poppy-950": colours.poppy["950"],

    "--colour-danger-50": colours.poppy["50"],
    "--colour-danger-100": colours.poppy["100"],
    "--colour-danger-200": colours.poppy["200"],
    "--colour-danger-300": colours.poppy["300"],
    "--colour-danger-400": colours.poppy["400"],
    "--colour-danger-500": colours.poppy["500"],
    "--colour-danger-600": colours.poppy["600"],
    "--colour-danger-700": colours.poppy["700"],
    "--colour-danger-800": colours.poppy["800"],
    "--colour-danger-900": colours.poppy["900"],
    "--colour-danger-950": colours.poppy["950"],

    "--colour-sunshade-50": colours.sunshade["50"],
    "--colour-sunshade-100": colours.sunshade["100"],
    "--colour-sunshade-200": colours.sunshade["200"],
    "--colour-sunshade-300": colours.sunshade["300"],
    "--colour-sunshade-400": colours.sunshade["400"],
    "--colour-sunshade-500": colours.sunshade["500"],
    "--colour-sunshade-600": colours.sunshade["600"],
    "--colour-sunshade-700": colours.sunshade["700"],
    "--colour-sunshade-800": colours.sunshade["800"],
    "--colour-sunshade-900": colours.sunshade["900"],
    "--colour-sunshade-950": colours.sunshade["950"],

    "--colour-warning-50": colours.sunshade["50"],
    "--colour-warning-100": colours.sunshade["100"],
    "--colour-warning-200": colours.sunshade["200"],
    "--colour-warning-300": colours.sunshade["300"],
    "--colour-warning-400": colours.sunshade["400"],
    "--colour-warning-500": colours.sunshade["500"],
    "--colour-warning-600": colours.sunshade["600"],
    "--colour-warning-700": colours.sunshade["700"],
    "--colour-warning-800": colours.sunshade["800"],
    "--colour-warning-900": colours.sunshade["900"],
    "--colour-warning-950": colours.sunshade["950"],

    "--colour-leaf-50": colours.leaf["50"],
    "--colour-leaf-100": colours.leaf["100"],
    "--colour-leaf-200": colours.leaf["200"],
    "--colour-leaf-300": colours.leaf["300"],
    "--colour-leaf-400": colours.leaf["400"],
    "--colour-leaf-500": colours.leaf["500"],
    "--colour-leaf-600": colours.leaf["600"],
    "--colour-leaf-700": colours.leaf["700"],
    "--colour-leaf-800": colours.leaf["800"],
    "--colour-leaf-900": colours.leaf["900"],
    "--colour-leaf-950": colours.leaf["950"],

    "--colour-success-50": colours.leaf["50"],
    "--colour-success-100": colours.leaf["100"],
    "--colour-success-200": colours.leaf["200"],
    "--colour-success-300": colours.leaf["300"],
    "--colour-success-400": colours.leaf["400"],
    "--colour-success-500": colours.leaf["500"],
    "--colour-success-600": colours.leaf["600"],
    "--colour-success-700": colours.leaf["700"],
    "--colour-success-800": colours.leaf["800"],
    "--colour-success-900": colours.leaf["900"],
    "--colour-success-950": colours.leaf["950"],

    "--colour-sky-50": colours.sky["50"],
    "--colour-sky-100": colours.sky["100"],
    "--colour-sky-200": colours.sky["200"],
    "--colour-sky-300": colours.sky["300"],
    "--colour-sky-400": colours.sky["400"],
    "--colour-sky-500": colours.sky["500"],
    "--colour-sky-600": colours.sky["600"],
    "--colour-sky-700": colours.sky["700"],
    "--colour-sky-800": colours.sky["800"],
    "--colour-sky-900": colours.sky["900"],
    "--colour-sky-950": colours.sky["950"],

    "--colour-info-50": colours.sky["50"],
    "--colour-info-100": colours.sky["100"],
    "--colour-info-200": colours.sky["200"],
    "--colour-info-300": colours.sky["300"],
    "--colour-info-400": colours.sky["400"],
    "--colour-info-500": colours.sky["500"],
    "--colour-info-600": colours.sky["600"],
    "--colour-info-700": colours.sky["700"],
    "--colour-info-800": colours.sky["800"],
    "--colour-info-900": colours.sky["900"],
    "--colour-info-950": colours.sky["950"],

    "--colour-lime-50": colours.lime["50"],
    "--colour-lime-100": colours.lime["100"],
    "--colour-lime-200": colours.lime["200"],
    "--colour-lime-300": colours.lime["300"],
    "--colour-lime-400": colours.lime["400"],
    "--colour-lime-500": colours.lime["500"],
    "--colour-lime-600": colours.lime["600"],
    "--colour-lime-700": colours.lime["700"],
    "--colour-lime-800": colours.lime["800"],
    "--colour-lime-900": colours.lime["900"],
    "--colour-lime-950": colours.lime["950"],

    "--colour-cyan-50": colours.cyan["50"],
    "--colour-cyan-100": colours.cyan["100"],
    "--colour-cyan-200": colours.cyan["200"],
    "--colour-cyan-300": colours.cyan["300"],
    "--colour-cyan-400": colours.cyan["400"],
    "--colour-cyan-500": colours.cyan["500"],
    "--colour-cyan-600": colours.cyan["600"],
    "--colour-cyan-700": colours.cyan["700"],
    "--colour-cyan-800": colours.cyan["800"],
    "--colour-cyan-900": colours.cyan["900"],
    "--colour-cyan-950": colours.cyan["950"],

    "--colour-indigo-50": colours.indigo["50"],
    "--colour-indigo-100": colours.indigo["100"],
    "--colour-indigo-200": colours.indigo["200"],
    "--colour-indigo-300": colours.indigo["300"],
    "--colour-indigo-400": colours.indigo["400"],
    "--colour-indigo-500": colours.indigo["500"],
    "--colour-indigo-600": colours.indigo["600"],
    "--colour-indigo-700": colours.indigo["700"],
    "--colour-indigo-800": colours.indigo["800"],
    "--colour-indigo-900": colours.indigo["900"],
    "--colour-indigo-950": colours.indigo["950"],

    "--colour-violet-50": colours.violet["50"],
    "--colour-violet-100": colours.violet["100"],
    "--colour-violet-200": colours.violet["200"],
    "--colour-violet-300": colours.violet["300"],
    "--colour-violet-400": colours.violet["400"],
    "--colour-violet-500": colours.violet["500"],
    "--colour-violet-600": colours.violet["600"],
    "--colour-violet-700": colours.violet["700"],
    "--colour-violet-800": colours.violet["800"],
    "--colour-violet-900": colours.violet["900"],
    "--colour-violet-950": colours.violet["950"],

    "--colour-fuchsia-50": colours.fuchsia["50"],
    "--colour-fuchsia-100": colours.fuchsia["100"],
    "--colour-fuchsia-200": colours.fuchsia["200"],
    "--colour-fuchsia-300": colours.fuchsia["300"],
    "--colour-fuchsia-400": colours.fuchsia["400"],
    "--colour-fuchsia-500": colours.fuchsia["500"],
    "--colour-fuchsia-600": colours.fuchsia["600"],
    "--colour-fuchsia-700": colours.fuchsia["700"],
    "--colour-fuchsia-800": colours.fuchsia["800"],
    "--colour-fuchsia-900": colours.fuchsia["900"],
    "--colour-fuchsia-950": colours.fuchsia["950"],

    "--colour-pink-50": colours.pink["50"],
    "--colour-pink-100": colours.pink["100"],
    "--colour-pink-200": colours.pink["200"],
    "--colour-pink-300": colours.pink["300"],
    "--colour-pink-400": colours.pink["400"],
    "--colour-pink-500": colours.pink["500"],
    "--colour-pink-600": colours.pink["600"],
    "--colour-pink-700": colours.pink["700"],
    "--colour-pink-800": colours.pink["800"],
    "--colour-pink-900": colours.pink["900"],
    "--colour-pink-950": colours.pink["950"],

    "--colour-indicator-thread": colours.indicators.thread.default,
    "--colour-indicator-thread-light": colours.indicators.thread.light,
    "--colour-indicator-sun": colours.indicators.sun.default,
    "--colour-indicator-sun-light": colours.indicators.sun.light,
    "--colour-indicator-lake": colours.indicators.lake.default,
    "--colour-indicator-lake-light": colours.indicators.lake.light,
    "--colour-indicator-coral": colours.indicators.coral.default,
    "--colour-indicator-coral-light": colours.indicators.coral.light,
    "--colour-indicator-sprout": colours.indicators.sprout.default,
    "--colour-indicator-sprout-light": colours.indicators.sprout.light,

    "--colour-surface-0": colours.surface["0"],
    "--colour-surface-50": colours.surface["50"],
    "--colour-surface-75": colours.surface["75"],
    "--colour-surface-100": colours.surface["100"],
    "--colour-surface-200": colours.surface["200"],
    "--colour-surface-300": colours.surface["300"],
    "--colour-surface-600": colours.surface["600"],
    "--colour-surface-700": colours.surface["700"],
    "--colour-surface-800": colours.surface["800"],
    "--colour-surface-900": colours.surface["900"],

    "--colour-text-0": colours.text["000"],
    "--colour-text-200": colours.text["200"],
    "--colour-text-400": colours.text["400"],
    "--colour-text-600": colours.text["600"],
    "--colour-text-800": colours.text["800"],

    "--colour-success": colours.status.success,
    "--colour-success-dark": colours.status.successDark,
    "--colour-success-light": colours.status.successLight,
    "--colour-warning": colours.status.warning,
    "--colour-warning-dark": colours.status.warningDark,
    "--colour-warning-light": colours.status.warningLight,
    "--colour-error-dark": colours.status.errorDark,
    "--colour-error": colours.status.error,
    "--colour-error-light": colours.status.errorLight,
    "--colour-info-dark": colours.status.infoDark,
    "--colour-info": colours.status.info,
    "--colour-info-light": colours.status.infoLight,

    "--legacy-validere-colour": colours.legacy.validereColour,
    "--legacy-link-colour": colours.legacy.linkColour,
    "--legacy-light-text-colour": colours.text["600"],
    "--legacy-status-completed-colour": colours.status.success,
    "--legacy-status-pending-colour": colours.status.warning,
    "--legacy-status-error-colour": colours.status.error,
    "--legacy-border-colour": colours.surface["200"],
    "--legacy-tooltip-colour": colours.legacy.tooltipColour,
    "--legacy-menu-highlight-colour": colours.surface["100"],
    "--legacy-disabled-font-colour": colours.legacy.disabledFontColour,
    "--legacy-alarm-colour": colours.status.warning,
    "--legacy-text-colour": colours.text["600"],
    "--legacy-disabled-row-colour": colours.surface["100"],
    "--legacy-colour-info": colours.legacy.info,
    "--legacy-colour-error": colours.legacy.error,
  },
};
